import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface ISpecialPriceProductSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const SpecialPriceProductSection = styled.div<ISpecialPriceProductSectionProps>`
  text-align: center;
  background: #fff;
  padding: 32px 0;

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      background: ${$bgColor};

      .content-title {
        color: ${$textColor};
      }

      .btn-folding {
        background: ${$bgColor} !important;

        &:after {
          background: linear-gradient(
            270deg,
            ${$bgColor} 29.17%,
            rgba(255, 255, 255, 0) 100%
          ) !important;
        }
      }

      .category-tab {
        &.cm-type7 {
          .swiper:after {
            background: #eee;
          }

          .item.active .area-click {
            color: ${$textColor} !important;

            &:after {
              background: ${$textColor} !important;
            }
          }
        }

        &.cm-type1 {
          .menubar-swiper {
            background: ${$bgColor};

            .menubar-item {
              .area-click {
                color: ${$textColor};
              }

              &.active .area-click {
                background: ${$pointColor};
                color: ${$emphasisTextColor};
              }
            }
          }
        }

        .menu2line-item {
          &.active {
            background: ${$pointColor};
            border-color: ${$pointColor};

            .text {
              color: ${$emphasisTextColor};
            }
          }
        }
      }

      .coming-soon {
        background: ${$bgColor} !important;
        opacity: 0.6;
      }

      .product-item .tag.tag-soldout {
        background: rgba(172, 172, 172, 0.15);
        color: #000;
      }

      .basic-btn {
        color: ${$textColor};

        svg path {
          stroke: ${$textColor};
        }
      }
    `}

  .img-banner {
    margin-bottom: 32px;

    img {
      position: static !important;
    }
  }

  .section-title {
    padding-bottom: 12px;
  }

  .date-tab {
    background: transparent;
    padding-top: 7px;
    padding-bottom: 7px;

    .menubar-swiper {
      background: transparent;
    }

    .swiper {
      padding: 0 20px;

      .swiper-wrapper {
        align-items: center;

        .swiper-slide {
          width: auto !important;
        }
      }
    }
  }

  .countdown-timer {
    margin: 7px auto 14px;
  }

  .category-tab {
    background: transparent;

    &.cm-type1 {
      padding: 7px 0 0;
    }

    + .product-wrap {
      margin-top: 16px;
    }
  }

  .coupon-wrap {
    padding: 16px 20px;
  }

  .btn-section-more {
    background: transparent;
  }

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .date-tab.category-menubar {
      .menubar-swiper {
        background: #000;
      }

      .btn-folding {
        background: #000;

        &:after {
          background: linear-gradient(
            270deg,
            #000 29.17%,
            rgba(0, 0, 0, 0) 100%
          );
        }

        svg {
          rect {
            stroke: #555;
          }

          path {
            fill: #acacac;
          }
        }
      }
    }

    .btn-section-more {
      border-color: #555;

      .text {
        color: #fff;
      }

      svg path {
        stroke: #fff;
      }
    }

    .coming-soon {
      background: rgba(0, 0, 0, 0.6);
    }
  }

  &.has-img-banner {
    padding-top: 0;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .img-banner {
      margin-bottom: ${mixin.pxToVw('32')};
    }

    .section-title {
      padding-bottom: ${mixin.pxToVw('12')};
    }

    .date-tab {
      padding-top: ${mixin.pxToVw('7')};
      padding-bottom: ${mixin.pxToVw('7')};

      .swiper {
        padding: ${mixin.pxToVw('0 20')};
      }
    }

    .countdown-timer {
      margin-top: ${mixin.pxToVw('7')};
      margin-bottom: ${mixin.pxToVw('14')};
    }

    .category-tab {
      &.cm-type1 {
        padding: ${mixin.pxToVw('7 0 0')};
      }

      + .product-wrap {
        margin-top: ${mixin.pxToVw('16')};
      }
    }

    .coupon-wrap {
      padding: ${mixin.pxToVw('16 20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    &.bg-type-black .category-tab .menu2line-item {
      color: #ccc;
      border-color: #555;

      &.active {
        background: #fff;

        .text {
          color: #000;
        }
      }
    }

    .img-banner {
      width: calc(100% + 114px);
      margin: 0 0 65px -57px;
    }

    .section-title {
      padding-bottom: 20px;

      + .product-wrap {
        margin-top: 0;
      }
    }

    .date-tab {
      ${mixin.flex({ justify: 'flex-start', align: 'center' })};
      gap: 0 10px;
      margin: 0;
      padding: 0;

      &.category-menubar {
        display: block;
        padding: 0;

        .category-fold {
          padding-right: 64px;

          .swiper {
            padding: 0 25px 0 0;
          }
        }

        .btn-folding {
          width: 64px;
          height: 80px;
          top: 0;
          right: 0;
          background: #fff;

          &:after {
            width: 20px;
            top: 0;
            right: 100%;
            height: 100%;
            background: linear-gradient(
              270deg,
              #fff 29.17%,
              rgba(255, 255, 255, 0) 100%
            );
          }

          svg {
            width: 44px;
            height: 44px;
          }
        }
      }
    }

    // event와 동일 컴포넌트 사용으로 display와 pc 해상도 기준점이 달라 스타일 재선언 함 start
    .countdown-timer {
      width: 100%;
      height: 50px;
      font-size: 18px;
      line-height: 50px;
      padding: 0 40px;
      margin: 20px 0 30px;
      gap: 0 20px;
    }
    // event와 동일 컴포넌트 사용으로 display와 pc 해상도 기준점이 달라 스타일 재선언 함 end

    .coupon-wrap {
      padding: 16px 0;

      + .category-tab {
        margin-top: 30px;
      }
    }

    .category-tab {
      &:not(.category-menubar) {
        ${mixin.flex({ wrap: 'wrap', justify: 'flex-start', align: 'center' })};
        gap: 12px;

        + .product-wrap {
          margin-top: 20px;
        }
      }

      + .product-wrap {
        margin-top: 30px;
      }
    }
  }
`;

export const ProductList = styled.div`
  position: relative;

  &.more-product:not(.event-status-3) {
    .btn-section-more {
      display: none;
    }
  }

  .product-list {
    padding: 0 20px;
  }

  .coming-soon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);
    z-index: 1;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .product-list {
      padding: ${mixin.pxToVw('0 20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    margin-top: 30px;

    .btn-section-more {
      margin-top: 48px;
    }

    .product-list {
      padding: 0;
    }
  }
`;
